/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Pakasir_NoteInputs */

const en_billing_pakasir_note = /** @type {(inputs: Billing_Pakasir_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IDR checkout runs on Pakasir — QRIS and virtual accounts from every major bank.`)
};

const id_billing_pakasir_note = /** @type {(inputs: Billing_Pakasir_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembayaran rupiah lewat Pakasir — QRIS dan Virtual Account semua bank besar.`)
};

/**
* | output |
* | --- |
* | "IDR checkout runs on Pakasir — QRIS and virtual accounts from every major bank." |
*
* @param {Billing_Pakasir_NoteInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const billing_pakasir_note = /** @type {((inputs?: Billing_Pakasir_NoteInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Pakasir_NoteInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_billing_pakasir_note(inputs)
	return en_billing_pakasir_note(inputs)
});